import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { deleteQuestion } from "../../../api/endpoints/QuestionEndpoints";

export default function useDeleteQuestion() {
  return useMutation<void, AxiosError, { quizId: number; questionId: string }>({
    mutationKey: ["delete-question"],
    mutationFn: ({ quizId, questionId }) => deleteQuestion(quizId, questionId),
  });
}
